import { Table } from "antd";
import type { ColumnFilterItem, Key, SorterResult, TablePaginationConfig } from "antd/es/table/interface";
import type { ColumnType } from "antd/lib/table/interface";
import React, { type FC, type ReactNode, useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import type { AcquirerEntity } from "src/app/features/Acquirer/types/AcquirerEntity";
import type { AcquirerList } from "src/app/features/Acquirer/types/AcquirerList";
import type { ExtendedColumnsType } from "../../components";
import {
    displayDateTimeValue,
    displayStatusValue,
} from "../../components/Table/components/PropertyTable/transformations/cellTransformations";
import { HtmlPaginationStyle, HtmlTableContainerStyle, HtmlTableStyle } from "../../components/Table/styles/HtmlTableStyle";
import { TableColumnWidth } from "../../components/Table/types/types";
import type { Entity } from "../../core/types/fe/Entity";

export const TableDocs = () => {
    const initialState = {
        datasource: {
            data: [
                {
                    id: 1305,
                    name: "test2",
                    status: true,
                    type: "LOYALTY_ACQUIRER",
                    serviceName: "test",
                    services: ["DCC", "TOKENISATION_SERVICE"],
                    typeCheckReadOnly: false,
                    changed: "2024-01-17T11:29:27.179Z",
                    hostTerminalIdType: "DEFAULT",
                    hostTerminalIdUniqDisabled: false,
                    hostDeviceIdType: "GENERATE",
                    hostDeviceIdMask: "[0-9]",
                    hostDeviceIdUniqDisabled: false,
                    code: "6789",
                    acquirerId: "yrst",
                    acquirerIdCheckReadOnly: false,
                    hostConfigXmlId: 180,
                    maxSfQueueSize: 3,
                    maxSfQueueAmount: 3,
                    maxSfQueueTries: 3,
                    maxSfQueueAge: 3,
                    maxSfQueueSizeOffline: 3,
                    sfJobInterval: 1,
                    sfThrottleDefaultValue: 3,
                    nonFinancialTimeout: 3,
                    authTimeout: 3,
                    batchCloseType: "BEFORE_RECONCILIATION",
                    acquirerToVirtuals: [],
                    hostOperators: [],
                    numberOfContractsOrgUnits: 0,
                    isPhysical: true,
                    hostConfigXml: "Barclays UK Ireland (copy)",
                    contracts: [],
                },
                {
                    id: 705,
                    name: "Equens MV",
                    status: true,
                    type: "ACQUIRER",
                    serviceName: "HC-EQUENS",
                    services: [],
                    typeCheckReadOnly: false,
                    changed: "2024-01-12T13:02:07.310Z",
                    hostTerminalIdType: "EDIT",
                    hostTerminalIdMask: "[A-Z][A-Z][A-Z][0-9][0-9][0-9][0-9][0-9]",
                    hostTerminalIdUniqDisabled: true,
                    hostDeviceIdMask: "[0-9][0-9][0-9][0-9][0-9][0-9]",
                    hostDeviceIdUniqDisabled: false,
                    code: "equensmv",
                    acquirerId: "6730020089",
                    acquirerIdCheckReadOnly: false,
                    hostConfigXmlId: 120,
                    maxSfQueueSize: 1000000,
                    maxSfQueueAmount: 9999999,
                    maxSfQueueTries: 9999,
                    maxSfQueueAge: 3600,
                    sfJobInterval: 60,
                    sfThrottleDefaultValue: 60,
                    nonFinancialTimeout: 30,
                    authTimeout: 30,
                    batchCloseType: "AFTER_SUCCESSFUL_RECONCILIATION",
                    acquirerToVirtuals: [],
                    hostOperators: [],
                    numberOfContractsOrgUnits: 52,
                    isPhysical: true,
                    hostConfigXml: "Equens",
                    contracts: [
                        {
                            id: 3942,
                            contractNumber: "EquensMV",
                            siteName: "Rabo Equens 135510",
                            validFrom: "2023-11-13T00:00:00.000Z",
                            changed: "2024-01-12T12:45:57.549Z",
                            isPhysical: true,
                        },
                        {
                            id: 2662,
                            contractNumber: "RBEquensTest6MV",
                            siteName: "Rabo Equens 135510",
                            validFrom: "2022-12-01T00:00:00.000Z",
                            changed: "2024-01-12T12:46:02.092Z",
                            isPhysical: true,
                        },
                    ],
                },
                {
                    id: 1105,
                    name: "EquensUnify",
                    status: true,
                    type: "ACQUIRER",
                    serviceName: "HC-EQUENS",
                    services: [],
                    typeCheckReadOnly: false,
                    changed: "2023-09-07T15:14:24.408+01:00",
                    hostTerminalIdType: "DEFAULT",
                    hostTerminalIdUniqDisabled: false,
                    hostDeviceIdMask: "[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]",
                    hostDeviceIdUniqDisabled: false,
                    code: "equensu",
                    acquirerId: "673801000",
                    acquirerIdCheckReadOnly: false,
                    hostConfigXmlId: 280,
                    maxSfQueueSize: 1000000,
                    maxSfQueueAmount: 1000000,
                    maxSfQueueTries: 9999,
                    maxSfQueueAge: 360,
                    sfJobInterval: 60,
                    sfThrottleDefaultValue: 60,
                    nonFinancialTimeout: 30,
                    authTimeout: 30,
                    batchCloseType: "AFTER_SUCCESSFUL_RECONCILIATION",
                    acquirerToVirtuals: [],
                    hostOperators: [],
                    numberOfContractsOrgUnits: 0,
                    isPhysical: true,
                    hostConfigXml: "UNIFI",
                    contracts: [],
                },
                {
                    id: 1305,
                    name: "test2",
                    status: true,
                    type: "LOYALTY_ACQUIRER",
                    serviceName: "test",
                    services: ["DCC", "TOKENISATION_SERVICE"],
                    typeCheckReadOnly: false,
                    changed: "2024-01-17T11:29:27.179Z",
                    hostTerminalIdType: "DEFAULT",
                    hostTerminalIdUniqDisabled: false,
                    hostDeviceIdType: "GENERATE",
                    hostDeviceIdMask: "[0-9]",
                    hostDeviceIdUniqDisabled: false,
                    code: "6789",
                    acquirerId: "yrst",
                    acquirerIdCheckReadOnly: false,
                    hostConfigXmlId: 180,
                    maxSfQueueSize: 3,
                    maxSfQueueAmount: 3,
                    maxSfQueueTries: 3,
                    maxSfQueueAge: 3,
                    maxSfQueueSizeOffline: 3,
                    sfJobInterval: 1,
                    sfThrottleDefaultValue: 3,
                    nonFinancialTimeout: 3,
                    authTimeout: 3,
                    batchCloseType: "BEFORE_RECONCILIATION",
                    acquirerToVirtuals: [],
                    hostOperators: [],
                    numberOfContractsOrgUnits: 0,
                    isPhysical: true,
                    hostConfigXml: "Barclays UK Ireland (copy)",
                    contracts: [],
                },
            ],
            pageNumber: 1,
            pageSize: 2,
            totalPages: 2,
            totalNumberOfResults: 4,
            isFetching: false,
        },
    };

    const { t } = useTranslation();

    const getColumnsConfig = useCallback(
        (sortInfo: SorterResult<AcquirerList>): ExtendedColumnsType<AcquirerList>[] => {
            return [
                {
                    title: t("acquirerList.id"),
                    key: "id",
                    dataIndex: "id",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "id" ? sortInfo.order : null,
                },
                {
                    title: t("acquirerList.name"),
                    key: "name",
                    dataIndex: "name",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "name" ? sortInfo.order : null,
                },
                {
                    title: t("acquirerList.numberOfSites"),
                    key: "numberOfSites",
                    dataIndex: "numberOfSites",
                    sorter: (a, b) => a.numberOfSites! - b.numberOfSites!,
                    sortOrder: sortInfo.columnKey === "numberOfSites" ? sortInfo.order : null,
                },
                {
                    title: t("acquirerList.status"),
                    key: "status",
                    dataIndex: "status",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "status" ? sortInfo.order : null,
                    render: (value) => displayStatusValue(value),
                },
                {
                    title: t("acquirerList.changed"),
                    dataIndex: "changed",
                    key: "changed",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "changed" ? sortInfo.order : null,
                    width: "300px",
                    render: (value) => displayDateTimeValue(value),
                },
            ];
        },
        [t],
    );

    const [state] = useState(initialState);

    const [pageSize] = useState(state.datasource.pageSize);
    const [currentPage] = useState(state.datasource.pageNumber);
    //
    const [selectedRowKeys, setSelectedRowKeys] = useState<Key[]>([]);
    const [sortInfo] = useState<SorterResult<AcquirerList>>({});

    const columns = useMemo(() => getColumnsConfig(sortInfo), [sortInfo, getColumnsConfig]);

    // @ts-ignore
    const columnConfig = extendColumnConfig<AcquirerList>(columns, (state.datasource?.data || []) as readonly AcquirerEntity[]);

    const onSelectChange = (newSelectedRowKeys: Key[]) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const paginationFinal = {
        pageSize,
        current: currentPage,
        placement: ["bottomCenter"],
        // hideOnSinglePage: true,
    } as TablePaginationConfig;
    if (state.datasource?.totalNumberOfResults) {
        paginationFinal.total = state.datasource.totalNumberOfResults!;
    }

    return (
        <>
            <>
                AntD Table
                <Table
                    loading={state.datasource?.isFetching}
                    rowSelection={rowSelection}
                    columns={columnConfig}
                    // @ts-ignore
                    dataSource={addKeyProp<AcquirerList>((state.datasource?.data || []) as readonly AcquirerList[])}
                    pagination={paginationFinal}
                    onRow={undefined}
                    className="aevi-table"
                />
            </>
            <>
                HTML Table
                <HtmlTableContainerStyle>
                    <HtmlTableStyle>
                        <HtmlTableHeader>
                            <HtmlTableRow>
                                <HtmlTableHeaderCell value="Column 1" width={TableColumnWidth.MEDIUM} />
                                <HtmlTableHeaderCell value="Column 2" />
                                <HtmlTableHeaderCell value="Column 3" />
                            </HtmlTableRow>
                        </HtmlTableHeader>
                        <HtmlTableBody>
                            <HtmlTableRow>
                                <HtmlTableCell value="hello this is a long name for testing hello_this_is_a_long_name_for_testing_it_is_long test" />
                                <HtmlTableCell value="goodbye short_name" />
                                <HtmlTableCell value="more goodbye hello_this_is_a_long_name_for_testing_it_is_long" />
                            </HtmlTableRow>
                            <HtmlTableRow>
                                <HtmlTableCell value="html color badges" />
                                <HtmlTableCell value={displayStatusValue(false)} />
                                <HtmlTableCell value={displayStatusValue(true)} />
                            </HtmlTableRow>
                            <HtmlTableRow>
                                <HtmlTableCell value="hi" />
                                <HtmlTableCell value="bye" />
                                <HtmlTableCell value="hey" />
                            </HtmlTableRow>
                        </HtmlTableBody>
                    </HtmlTableStyle>
                </HtmlTableContainerStyle>
                <HtmlPaginationStyle>
                    <ul>
                        <li>
                            <svg className="aevi-table-pagination-disabled" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
                                <path d="M7 12.5 17.293 2l.707.707L8.414 12.5 18 22.293l-.707.707L7 12.5z" />
                            </svg>
                        </li>
                        <li>
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a href="" className="aevi-table-pagination-active">
                                1
                            </a>
                        </li>
                        <li>
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a>2</a>
                        </li>
                        <li>
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a>3</a>
                        </li>
                        <li>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
                                <path d="M18 12.5 7.707 23 7 22.293l9.586-9.793L7 2.707 7.707 2 18 12.5z" />
                            </svg>
                        </li>
                    </ul>
                </HtmlPaginationStyle>
            </>
        </>
    );
};

interface HtmlTableProps {
    // eslint-disable-next-line react/no-unused-prop-types
    value?: string | React.JSX.Element;
    // eslint-disable-next-line react/no-unused-prop-types
    width?: TableColumnWidth;
    // eslint-disable-next-line react/no-unused-prop-types
    children?: ReactNode;
}

export const HtmlTableCell: FC<HtmlTableProps> = ({ value }) => {
    return <td>{value}</td>;
};

export const HtmlTableHeaderCell: FC<HtmlTableProps> = ({ value, width }) => {
    return width ? <th style={{ maxWidth: `${width}` }}>{value}</th> : <th>{value}</th>;
};

export const HtmlTableRow: FC<HtmlTableProps> = ({ children }) => {
    return <tr>{children}</tr>;
};

export const HtmlTableBody: FC<HtmlTableProps> = ({ children }) => {
    return <tbody>{children}</tbody>;
};

export const HtmlTableHeader: FC<HtmlTableProps> = ({ children }) => {
    return <thead>{children}</thead>;
};

// eslint-disable-next-line @typescript-eslint/no-shadow
function extendColumnConfig<AcquirerList>(
    columns: ExtendedColumnsType<AcquirerList>[],
    data: ReadonlyArray<AcquirerList>,
): ColumnType<AcquirerList>[] {
    return columns.map((column) => {
        const { dataIndex, useUniqueValuesAsFilter } = column;

        if (useUniqueValuesAsFilter && dataIndex) {
            return addUniqueValuesAsFilters(
                column as ExtendedColumnsType<Record<string, unknown>>,
                data as ReadonlyArray<Record<string, unknown>>,
            ) as ExtendedColumnsType<AcquirerList>;
        }

        return column;
    }) as ColumnType<AcquirerList>[];
}

function addUniqueValuesAsFilters<T extends Record<string, unknown>>(column: ExtendedColumnsType<T>, data: ReadonlyArray<T>) {
    const { dataIndex } = column;

    if (dataIndex) {
        const filters = new Set();
        const columnClone = { ...column };

        delete columnClone.useUniqueValuesAsFilter;

        columnClone.filters = data
            .map((row) => {
                if (dataIndex in row) {
                    const val = row[dataIndex as keyof T];
                    if (val && !filters.has(val)) {
                        filters.add(val);
                        return { text: val, value: val };
                    }
                }
                return null;
            })
            .filter(Boolean) as unknown as ColumnFilterItem[];

        return columnClone;
    }
    return column;
}

// antd table requires to have a key prop in the table's row object, otherwise
// it will log warning in the console
// eslint-disable-next-line @typescript-eslint/no-shadow
function addKeyProp<AcquirerList extends Entity>(array: ReadonlyArray<AcquirerList>) {
    return array.map((obj) => {
        return { ...obj, key: obj.id };
    });
}
